/* unplugin-vue-components disabled */import { render } from "./about.vue?vue&type=template&id=f35d6932&scoped=true"
const script = {}

import "./about.vue?vue&type=style&index=0&id=f35d6932&scoped=true&lang=less"

import exportComponent from "/Users/yfy/work/work/cms-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f35d6932"]])

export default __exports__